import { Container, Grid } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import ClientEditSidebar, {
    ACTIVE_CLIENT_SIDEBAR_TAB_NAMES
} from '../clientedit/ClientEditSidebar';
import ClientActivitiesListPage from './components/ClientActivitiesListPage';

const ClientActivitiesPage = () => {
    const { clientId } = useParams();

    return (
        <Container fixed className="activity-edit page">
            <Grid className="pageWithSidebar">
                <ClientEditSidebar activeTab={ACTIVE_CLIENT_SIDEBAR_TAB_NAMES.clientactivities} />
                <Grid className="pageContent">
                    <ClientActivitiesListPage clientId={clientId} />
                </Grid>
            </Grid>
        </Container>
    );
};

export default ClientActivitiesPage;
